import * as React from "react";
import type { AppFlexMenuProps } from "./AppFlexMenu.types";
import { renderAppFlexMenu } from "./renderAppFlexMenu";
import { useAppFlexMenu } from "./useAppFlexMenu";

export const AppFlexMenu = React.memo<AppFlexMenuProps>((props) => {
  const state = useAppFlexMenu(props);
  return renderAppFlexMenu(state);
});

AppFlexMenu.displayName = "AppFlexMenu";
